var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCompanySelected = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.974 11.7911C14.1843 11.7911 14.3615 11.7911 14.5275 11.7911V4.59464H10.9791V11.7911H13.974Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.876465 2.14786V3.4875H16.3765V2.14786L8.62646 0L0.876465 2.14786Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.27896 11.7911H6.27379V4.59464H2.72539V11.7911C2.89146 11.7911 3.06861 11.7911 3.27896 11.7911Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3765 15.2896C16.3765 14.3818 16.3765 13.8725 16.2436 13.6068C16.1218 13.3632 15.9225 13.1639 15.679 13.0421C15.5572 12.9757 15.369 12.9425 15.059 12.9314C14.7711 12.9093 14.439 12.9093 13.985 12.9093H3.27896C2.82504 12.9093 2.49289 12.9093 2.21611 12.9314C1.90611 12.9536 1.71789 12.9868 1.58504 13.0532C1.34146 13.175 1.14218 13.3743 1.02039 13.6179C0.876465 13.8946 0.876465 14.3929 0.876465 15.3118V15.5H16.3765V15.2896Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCompanySelected);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/companySelected.4f4ba2dc86ee754a970d94bdc0ce5a82.svg";